
import { Button } from '../../../components/base/Button';

export const HeroSection = () => {
  return (
    <section className="relative pt-20 pb-16 bg-gradient-to-br from-blue-50 via-white to-cyan-50 overflow-hidden">
      <div className="absolute inset-0 bg-[url('https://public.readdy.ai/ai/img_res/f7a1171bacc2561a99b2d71b49317aee.jpg')] bg-cover bg-center bg-no-repeat opacity-10"></div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <div className="inline-flex items-center px-4 py-2 bg-blue-100 text-blue-800 rounded-full text-sm font-medium mb-6">
            <i className="ri-funds-line mr-2"></i>
            Series A 펀딩 라운드 진행중
          </div>
          
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6 leading-tight">
            해양 바이오 혁신의
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-cyan-600 block">
              미래에 투자하세요
            </span>
          </h1>
          
          <p className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto leading-relaxed">
            MarineBioGroup과 함께 지속 가능한 해양 바이오 기술로 세상을 변화시키는 여정에 동참하세요. 
            친환경 소재와 혁신적인 바이오 제품으로 미래 시장을 선도할 기회입니다.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
            <Button variant="primary" size="lg" className="text-lg px-8 py-4">
              <i className="ri-funds-line mr-2"></i>
              지금 투자하기
            </Button>
            <Button variant="outline" size="lg" className="text-lg px-8 py-4">
              <i className="ri-play-circle-line mr-2"></i>
              프로젝트 소개 영상
            </Button>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 max-w-4xl mx-auto">
            <div className="text-center">
              <div className="text-3xl font-bold text-blue-600 mb-2">$2.5M</div>
              <div className="text-sm text-gray-600">목표 펀딩</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-green-600 mb-2">$1.8M</div>
              <div className="text-sm text-gray-600">현재 펀딩</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-purple-600 mb-2">72%</div>
              <div className="text-sm text-gray-600">달성률</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-orange-600 mb-2">45일</div>
              <div className="text-sm text-gray-600">남은 기간</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
